import { getEventQueue } from '../../../shared/utils/eventQueue';
import { IApplicationContext } from '../../../shared/types';
import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

export function createApplicationContext(): IApplicationContext {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContext['custom']>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
    telemetry: getTelemetry(),
    eventQueue: getEventQueue(),
  };
}
